import { render, staticRenderFns } from "./IntegrationImportShopifyShippingsMessage.vue?vue&type=template&id=dd07665a"
import script from "./IntegrationImportShopifyShippingsMessage.vue?vue&type=script&lang=js"
export * from "./IntegrationImportShopifyShippingsMessage.vue?vue&type=script&lang=js"
import style0 from "./IntegrationImportShopifyShippingsMessage.vue?vue&type=style&index=0&id=dd07665a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports